import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import * as idb from '../../../functions/databaseService/indexedDB';
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_ERROR = "DELETE_COMMENT_ERROR";

// Thunk Action Creator
export const deleteCommentFromTask = createAsyncThunk(
    "api/Task/deleteComment",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/deleteComment/${json.id}`,
                    {
                        id: json.id,
                        CommentId: json.CommentId
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.status === 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }                }
                else {
                    throw new Error("Error deleting comment from task");
                }

                // Get data from IndexedDB
                //const taskListData = await idb.getTasks();

                dispatch({
                    type: DELETE_COMMENT_SUCCESS,
                    payload: response.data,
                });

            } else {
                // Get data from IndexedDB when offline
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    // Dispatch success action with data from IndexedDB
                    dispatch({
                        type: DELETE_COMMENT_SUCCESS,
                        payload: taskListData,
                    });
                } else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        } catch (error) {
            // Dispatch error action if any exception occurs
            dispatch({ type: DELETE_COMMENT_ERROR, payload: error });
            await signOut();
        }
        //.then(response => {
        //    dispatch({
        //        type: DELETE_COMMENT_SUCCESS,
        //        payload: response.data,
        //    });
        //})
        //.catch(error => {
        //    dispatch({ type: DELETE_COMMENT_ERROR, payload: error });
        //});
        //}
    }
);
